import * as Yup from 'yup';
import { bindYupMethods } from './bindYupMethods';

export const customYup = bindYupMethods(Yup);
